import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ImageGrid.css'; // Import CSS for styling
import { pathExtention } from '../../Utills/utils';
import { useTranslation } from 'react-i18next';

const ImageGrid = ({ imageData }) => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const localize = (value) => t(value, { defaultValue: value });

  const handleImageClick = (path) => {
    // const currentPath = window.location.pathname;
    // const newPath = currentPath.endsWith('/') ? currentPath + path : currentPath + '/' + path;
    // navigate(newPath);
    navigate(pathExtention(path));
  };

 return (
  <div className="image-grid-container">
    {imageData.map((item, index) => (
      <button
        key={index}
        className="image-button"
        onClick={() => handleImageClick(item.navigateTo)}
      >
        {item.imageUrl === "img" ? (
               <img
            src="/notification.png"
            alt={localize(item.altText)}
            className="grid-image"
            width="64"
            height="64"
          />
        ) : (
      

             <img
            src={item.imageUrl}
            alt={localize(item.altText)}
            className="grid-image"
          />
        )}

        <div className="image-label">{localize(item.title).toLocaleUpperCase(i18n.resolvedLanguage)}</div>
      </button>
    ))}
  </div>
);

};

export default ImageGrid;
